<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="3" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Add Recharge Coin
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.offer_name"
                outlined
                label="Offer Name"
                prepend-inner-icon="mdi-tag"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.recharge_amount"
                outlined
                label="Recharge Amount"
                type="number"
                prepend-inner-icon="mdi-currency-inr"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.coin_earned"
                outlined
                label="Coins Earned"
                type="number"
                prepend-inner-icon="mdi mdi-bitcoin"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.bonus"
                outlined
                label="Bonus(+)"
                type="number"
                prepend-inner-icon="mdi mdi-bitcoin"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Recharge Coin
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "RechargeCoinCreatePage",
  data() {
    return {
      form: {
        company_id: 1,
        offer_name: "",
        recharge_amount: "",
        coin_earned: "",
        bonus: "",
      },
      isLoading: false,
    };
  },
  methods: {
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/recharge_coins", this.form);
        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.push("/recharge-coins");
      } catch (e) {
        // alert("error");
        console.log(e);
        this.isLoading = false;
      }
    },
  },
};
</script>
